import { render, staticRenderFns } from "./FactTable.vue?vue&type=template&id=6d510aa8&scoped=true&"
import script from "./FactTable.vue?vue&type=script&lang=js&"
export * from "./FactTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d510aa8",
  null
  
)

export default component.exports